module.exports = __webpack_public_path__ + "img/app_icon_warn.99152ec9.png";